/**
 * Money is whole cents in an integer, everywhere. Floating-point dollars drift: 0.1 + 0.2 is not
 * 0.3, and a subscription that adds add-on prices in floats bills a cent wrong eventually.
 */

export type Cents = number;

export function cents(dollars: number): Cents {
  return Math.round(dollars * 100);
}

/** "$175" for whole dollars, "$175.50" otherwise. US dollars only, since Lattice sells in the US. */
export function formatUsd(amount: Cents): string {
  const whole = amount % 100 === 0;

  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: whole ? 0 : 2,
    maximumFractionDigits: whole ? 0 : 2,
  }).format(amount / 100);
}
